
namespace RedBullMOBILE360.SMSCodes {
    export class ServiceSmsColumns {
        static columnsKey = 'SMSCodes.ServiceSms';
    }
}